
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]/contents",
      function () {
        return require("private-next-pages/festivals/[festivalId]/contents/index.tsx");
      }
    ]);
  